/**
 * @fileoverview
 * Space System for game logic
 */
'use strict';

goog.provide("Ntry.Mapper");

goog.require("Ntry.STATIC");
goog.require("Ntry.Utils");

Ntry.Mapper = function() {
    this.isEnabled = false;

    this._isGenerate = false;

    this._updateRequired = false;

    this.previousLine = {};

    this.bgA = null;
    this.bgB = null;

    Ntry.addEventListener("gridChange", this, this.toggleUpdate);
    Ntry.addEventListener("run", this, this.toggleRun);
    Ntry.addEventListener("stop", this, this.toggleStop);
};

(function(p){
    p.backWidth = 700;

    p.start = 1600;

    p.backPath = "stage_infinite";

    p.loadConfig = function() {
        this.isEnabled = Ntry.configManager.getConfig("mapper") ? true : false;
    };

    p.update = function() {
        if (this.isEnabled && !this.bgA) {
            this.bgA = this.createBG(true);
            this.bgB = this.createBG();
        }
        if (this._updateRequired) {
            this.updateMap();
            this._updateRequired = false;
        }
    };

    p.toggleRun = function() {
        if (!this.isEnabled)
            return;
        this._itemCount = 0;
        this._isGenerate = true;
    };

    p.toggleStop = function() {
        if (!this.isEnabled)
            return;
        this._isGenerate = false;
        this.clearMap();
    };

    p.toggleUpdate = function() {
        if (!this.isEnabled)
            return;
        this._updateRequired = true;
    }

    p.updateMap = function() {
        if (!this._isGenerate)
            return;

        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.RADAR
        );

        if (_.isEmpty(entities))
            return;

        var spaceShip = _.values(entities)[0];

        var shipGrid = Ntry.entityManager.getComponent(
            spaceShip.id, Ntry.STATIC.GRID
        );
        this.remainItem = 0;
        this.generateLine(shipGrid.x + 4);
        this.updateBG(shipGrid.x);
    };

    p.generateLine = function(x) {
        var meteos = [];
        if (x == 100) {
            var stageId = Ntry.configManager.getConfig("stageId");
            meteos.push(Ntry.createPlanet(x, 0, null));
            meteos.push(Ntry.createPlanet(x, 1, stageId));
            meteos.push(Ntry.createPlanet(x, 2, null));
            Ntry.entityManager.fromJSON(meteos);
            return;
        }
        else if (x > 100)
            return;
        var currentLine = {};
        for (var i = 0; i < 3; i++) {
            if (Math.random() < 0.2 + 0.4 * Math.min(x / 30, 1)) {
                meteos.push(
                    Ntry.createMeteo(x, i)
                );
                currentLine[i] = true;
            } else {
                if (Math.random() < 0.04) {
                    var item = Ntry.createSpaceItem(x, i);
                    meteos.push(item);
                    this._itemCount++;
                    this.remainItem++;
                }
                currentLine[i] = false;
            }
        }

        if (currentLine[0] && currentLine[1] && currentLine[2]) {
            if (!this.remainItem) {
                var deleteY = Math.floor(Math.random() * 3);
                meteos.splice(deleteY, 1);
                currentLine[deleteY] = false;
            } else {
                this.remainItem--;
            }
        }

        if (this.previousLine) {
            if ((!this.previousLine[0] && this.previousLine[1] &&
               currentLine[0] && currentLine[1]) ||
                (!this.previousLine[2] && this.previousLine[1] &&
                 currentLine[2] && currentLine[1])) {
                return this.generateLine(x);
            }
        }
        this.previousLine = currentLine;
        Ntry.entityManager.fromJSON(meteos);

        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.ITEM
        );

        for (var id in entities) {
            var gridComp = Ntry.entityManager.getComponent(
                id, Ntry.STATIC.GRID
            );
            if (gridComp.x < x - 5) {
                Ntry.entityManager.removeEntity(id);
            };
        }

    }

    p.clearMap = function() {
    };

    p.updateBG = function(x) {
        if (!this.isEnabled)
            return;
        if (x % 14 == 2) {
            position = Ntry.entityManager.getComponent(
                this.bgA.id, Ntry.STATIC.POSITION
            );
            position.x += this.backWidth * 2;
        }
        else if (x % 14 == 9) {
            position = Ntry.entityManager.getComponent(
                this.bgB.id, Ntry.STATIC.POSITION
            );
            position.x += this.backWidth * 2;
        };

    };

    p.createBG = function(isForA) {
        var bg = Ntry.entityManager.addEntity();
        Ntry.entityManager.addComponent(bg.id, {
            type: Ntry.STATIC.BITMAP,
            image: this.backPath,
            regX: 0,
            regY: 0
        });
        Ntry.entityManager.addComponent(bg.id, {
            type: Ntry.STATIC.GRID,
            x: 0, y: 0
        });
        Ntry.entityManager.addComponent(bg.id, {
            type: Ntry.STATIC.POSITION,
            x: isForA ? this.start - this.backWidth * 3 - 100:
                this.start- this.backWidth * 2 - 100,
            y: 0
        });
        return bg;
    };

    p.getScrollX = function() {
        if (!this._scroll) {
            var entities = Ntry.entityManager.getEntitiesByComponent(
                Ntry.STATIC.SCROLL
            )
            if (!entities)
                return 0;
            else {
                var scrollEntity;
                for (var key in entities)
                    this._scroll = Ntry.entityManager.getComponent(
                        key, Ntry.STATIC.SCROLL);
            }
        }
        return this._scroll.scrollX;
    };

})(Ntry.Mapper.prototype);
